 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Notification
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <!-- Insured -->
                <v-flex xs6 sm3 md3 lg3>
                  <v-checkbox
                    v-model="form.emailInsured"
                    :label="labels.emailInsured"
                    :error-messages="errors.collect('emailInsured')"
                    data-vv-name="emailInsured"
                    :data-vv-as="labels.emailInsured"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs18 sm9 md9 lg9>
                  <v-text-field
                    :disabled="!form.emailInsured"
                    v-model="form.emailAddressInsured"
                    :error-messages="errors.collect('emailAddressInsured')"
                    v-validate="'required|email'"
                    data-vv-name="emailAddressInsured"
                    :data-vv-as="labels.emailInsured"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md3 lg3>
                  <v-checkbox
                    v-model="form.smsInsured"
                    :label="labels.smsInsured"
                    :error-messages="errors.collect('smsInsured')"
                    data-vv-name="smsInsured"
                    :data-vv-as="labels.smsInsured"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs18 sm9 md9 lg9>
                  <v-text-field
                    :disabled="!form.smsInsured"
                    v-model="form.smsNumberInsured"
                    :error-messages="errors.collect('smsNumberInsured')"
                    data-vv-name="smsNumberInsured"
                    :data-vv-as="labels.smsInsured"
                    v-validate="'required|entry|max:20'"
                  ></v-text-field>
                </v-flex>
                <!-- Agent -->
                <v-flex xs6 sm3 md3 lg3>
                  <v-checkbox
                    v-model="form.emailAgent"
                    :label="labels.emailAgent"
                    :error-messages="errors.collect('emailAgent')"
                    data-vv-name="emailAgent"
                    :data-vv-as="labels.emailAgent"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs18 sm9 md9 lg9>
                  <v-text-field
                    :disabled="!form.emailAgent"
                    v-model="form.emailAddressAgent"
                    :error-messages="errors.collect('emailAddressAgent')"
                    v-validate="'required|email'"
                    data-vv-name="emailAddressAgent"
                    :data-vv-as="labels.emailAgent"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md3 lg3>
                  <v-checkbox
                    v-model="form.smsAgent"
                    :label="labels.smsAgent"
                    :error-messages="errors.collect('smsAgent')"
                    data-vv-name="smsAgent"
                    :data-vv-as="labels.smsAgent"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs18 sm9 md9 lg9>
                  <v-text-field
                    :disabled="!form.smsAgent"
                    v-model="form.smsNumberAgent"
                    :error-messages="errors.collect('smsNumberAgent')"
                    data-vv-name="smsNumberAgent"
                    v-validate="'required|entry|max:20'"
                    :data-vv-as="labels.smsAgent"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions left>
            <v-btn color="primary" @click.prevent="notifyProcNotif" :loading="loading"
              >Proceed<v-icon dark right>mdi-arrow-right-bold-box</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        emailInsured: 'Email Insured',
        smsInsured: 'SMS Insured',
        emailAgent: 'Email Agent',
        smsAgent: 'SMS Agent',
        process: 'Process'
      },
      form: {
        emailInsured: false,
        emailAddressInsured: '',
        smsInsured: false,
        smsNumberInsured: '',
        emailAgent: false,
        emailAddressAgent: '',
        smsAgent: false,
        smsNumberAgent: ''
      },
      loading: false
    }
  },
  mounted() {},
  methods: {
    async refreshForm() {
      this.form.emailInsured = this.procNotifData.emailInsured
      this.form.emailAddressInsured = this.procNotifData.emailAddressInsured
      this.form.smsInsured = this.procNotifData.smsInsured
      this.form.smsNumberInsured = this.procNotifData.smsNumberInsured
      this.form.emailAgent = this.procNotifData.emailAgent
      this.form.emailAddressAgent = this.procNotifData.emailAddressAgent
      this.form.smsAgent = this.procNotifData.smsAgent
      this.form.smsNumberAgent = this.procNotifData.smsNumberAgent
      this.loading = false
    },
    async fetchProcNotif() {
      this.loading = false
      this.resetMessages()
      await Promise.all([this.$emit('fetch')])
    },
    async notifyProcNotif() {
      this.loading = false
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.proceed()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async proceed() {
      this.loading = true
      await Promise.all([this.$emit('proceed', this.form)])
    }
  },
  props: {
    procNotifData: {
      type: Object,
      default: null
    }
  },
  computed: {},
  watch: {},
  mixins: [MessageMixin]
}
</script>
